import { createContext, useContext } from 'react';

/**
 * GenericTable styling variant.
 * - `v1`: the original GenericTable styling (WAE Table).
 * - `v2`: light blue header row, light dividers, outer border, no row hover; only row
 *   titles (and their column header) stay in place on mobile.
 */
export type GenericTableVariant = 'v1' | 'v2';

export const GenericTableVariantContext = createContext({ isV2: false });

export const useGenericTableVariant = () => useContext(GenericTableVariantContext);
